/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import _ from 'lodash';
import template from 'components/player/player-comparison/comparison-overview/comparison-overview.stache';

import { getToParTodayDisplayValue } from './comparison-overview.controller.ts';

can.Component.extend({
    tag: 'comparison-overview',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            firstPlayer: {
                Type: can.Map,
                Value: can.Map,
            },
            firstPlayerToParToday: {
                type: 'string',
            },
            secondPlayer: {
                Type: can.Map,
                Value: can.Map,
            },
            secondPlayerToParToday: {
                type: 'string',
            },
        },
    },
    events: {
        inserted() {
            const setToParToday = (value, field) => {
                const toParDisplayValue = getToParTodayDisplayValue(
                    value && value.serialize(),
                );
                this.viewModel.attr(field, toParDisplayValue);
            };
            this.viewModel.bind('firstPlayer', (_event, value) => {
                setToParToday(value, 'firstPlayerToParToday');
            });
            this.viewModel.bind('secondPlayer', (_event, value) => {
                setToParToday(value, 'secondPlayerToParToday');
            });
        },
    },
});
